import {
  DECISION_TRACKS,
  DECISION_TRACK_LIST,
  DecisionTrack,
} from "@/constants/decision-track";

import {
  isLossWithdrawn,
  isPayrollDiscount,
  PayrollDiscountCandidate,
} from "./is-payroll-discount";

interface TrackRule {
  readonly track: DecisionTrack;
  readonly matches: (candidate: PayrollDiscountCandidate) => boolean;
}

const TRACK_RULES: readonly TrackRule[] = [
  { track: DECISION_TRACKS.PAYROLL_DISCOUNT, matches: isPayrollDiscount },
  { track: DECISION_TRACKS.LOSS_WITHDRAWN, matches: isLossWithdrawn },
];

const FALLBACK_TRACK: DecisionTrack = DECISION_TRACKS.ACCOUNTED_LOSS;

export const trackOf = (candidate: PayrollDiscountCandidate): DecisionTrack =>
  TRACK_RULES.find((rule: TrackRule): boolean => rule.matches(candidate))
    ?.track ?? FALLBACK_TRACK;

const emptyGroupsOf = <TItem>(): Record<DecisionTrack, TItem[]> =>
  DECISION_TRACK_LIST.reduce(
    (
      groups: Record<DecisionTrack, TItem[]>,
      track: DecisionTrack
    ): Record<DecisionTrack, TItem[]> => ({ ...groups, [track]: [] }),
    {} as Record<DecisionTrack, TItem[]>
  );

export const groupByTrack = <TItem extends PayrollDiscountCandidate>(
  items: readonly TItem[]
): Record<DecisionTrack, TItem[]> => {
  const groups: Record<DecisionTrack, TItem[]> = emptyGroupsOf<TItem>();

  items.forEach((item: TItem): void => {
    groups[trackOf(item)].push(item);
  });

  return groups;
};

export const tracksPresentIn = <TItem extends PayrollDiscountCandidate>(
  groups: Record<DecisionTrack, TItem[]>
): readonly DecisionTrack[] =>
  DECISION_TRACK_LIST.filter(
    (track: DecisionTrack): boolean => groups[track].length > 0
  );
